import { useEffect, useState, useCallback } from "react";
import { useTranslation } from 'react-i18next';
import axios from "axios"
import authConfig from "../../authConfig";
import { useSelector, useDispatch } from 'react-redux';
import Button from 'react-bootstrap/Button';
import {
    AuthenticatedTemplate,
    UnauthenticatedTemplate,
    useMsal,
    useIsAuthenticated,
    useAccount
} from "@azure/msal-react"

import {
    format,
    subHours,
    startOfMonth,
    endOfMonth,
    formatISO,
    subMonths,
    getYear,
    addMonths,
    parseISO,
    parse,
    toDate
} from 'date-fns';
import { enGB, cy } from 'date-fns/locale';
import Container from 'react-bootstrap/Container';
import EditSitePagePopup from "./EditSitePagePopup";

function SitePage(props) {
    const { t, i18n } = useTranslation();

    const isAuthenticated = useIsAuthenticated();
    const { instance, accounts } = useMsal()
    const account = useAccount(accounts[0] || {})

    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (props.id !== undefined) {
            loadData()
        } else if (props.data) {
            setData(props.data);
        }
    }, [props])

    useEffect(() => {
        
    }, [data])
    //const [date, setDate] = useState(startOfMonth(Date.now()));

    const language = useSelector((state) => state.language.value);

    function loadData() {
        setError(null);
        setData(null);
        if (isAuthenticated) {
            if (account && loading == false) {
                setLoading(true)
                instance
                    .acquireTokenSilent({
                        scopes: authConfig.api.scopes,
                        account: account
                    })
                    .then(response => {
                        if (response) {
                            console.log("Got access token:", response)
                            axios
                                .create({
                                    headers: { Authorization: `Bearer ${response.accessToken}` }
                                })
                                .get(authConfig.api.urls.getSitePage + "/" + props.id)
                                .then(function (response) {
                                    console.log(response.data);
                                    setData(response.data);
                                })
                                .catch(function (error) {
                                    setError("Error fetching data: " + error.message)
                                    console.error(error)
                                })
                                .then(function () {
                                    // always executed
                                    setLoading(false)
                                })
                        } else {
                            setError("Empty token??")
                            console.error("no token acquired")
                        }
                    })
                    .catch(error => {
                        setError("Error getting token: " + error.message)
                        console.error(error)
                        setLoading(false)
                    })
            } else {
                setError("No account...")
            }
        } else {
            axios
                .create({
                    /*headers: { Authorization: `Bearer ${response.accessToken}` }*/
                })
                .get(authConfig.api.urls.getSitePage + "/" + props.id)
                .then(function (response) {
                    console.log(response.data);
                    
                    setData(response.data);
                })
                .catch(function (error) {
                    setError("Error fetching data: " + error.message)
                    console.error(error)
                })
                .then(function () {
                    // always executed
                    setLoading(false)
                })
        }
    }
    const handleChange = (d) => {
        console.log("handleChange:sitepage ",d)
        setData({ ...d });
    }
    //
    function getFormattedDate(date) {
        if (date) {
            return format(new Date(date), "EEEE, do LLLL, yyyy h:mm bbb", { locale: i18n.language == 'en' ? enGB : cy });
        } else {
            return "";
        }
    }
    return data === null || data === undefined ?
        (<></>) :
        (
            <>
                {isAuthenticated ? (
                    <EditSitePagePopup data={data} onChange={ handleChange} />
                ) : ''}
                {language === 'cy' ?
                    (<h1>{data.titleCy}</h1>)
                    :
                    (<h1>{data.titleEn}</h1>)
                }
                
                {
                    data.items ? data.items.map((item, index) => (
                            <div key={index}>
                                {item.titleCy ? (<h2>{language === 'cy' ? item.titleCy : item.titleEn}</h2>) : ''}
                                <div dangerouslySetInnerHTML={{ __html: language === 'cy' ? item.htmlCy : item.htmlEn }} />
                            </div>
                    )) : ''
                }
                

            </>
        )
}
export default SitePage;